import React, { useState } from 'react';
import { useStateContext } from '../contexts/ContextProvider';
import { Link, NavLink } from 'react-router-dom';
import {
	MdCategory,
	MdOutlineCancel,
} from 'react-icons/md';
import logo from '../data/logo.png';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { isAdmin } from '../data/utils';
import { AiOutlineAlert, AiOutlineDashboard, AiOutlineUser } from 'react-icons/ai';

const Sidebar = () => {
	const { currentColor, setActiveMenu, activeMenu, screenSize } =
		useStateContext();

	const links = [
		{
			title: ``,
			enabled: true,
			links: [
				{
					name: 'Tableau de bord',
					value: 'dashboard',
					icon: <AiOutlineDashboard />,
					enabled: true
				},
				{
					name: 'Alertes',
					value: 'alerts',
					icon: <AiOutlineAlert />,
					enabled: true
				},
				{
					name: 'Catégories',
					value: 'categories',
					icon: <MdCategory />,
					enabled: isAdmin()
				},
				{
					name: 'Utilisateurs',
					value: 'users',
					icon: <AiOutlineUser />,
					enabled: true
				},
			],
		},
	];



	const handleCloseSidebar = () => {
		if (activeMenu !== undefined && screenSize <= 900) {
			setActiveMenu(false);
		}
	};


	const activeLink =
		'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-white text-md m-2';
	const normalLink =
		'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2';

	return (
		<div className='ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10'>
			{activeMenu && (
				<>
					<div className='flex justify-between items-center'>
						<Link
							to='/'
							onClick={handleCloseSidebar}
							className='flex justify-center p-4 text-xl font-extrabold tracking-tight dark:text-white text-slate-900'
						>
							<img className='rounded-xl' width={'auto'} src={logo} />
						</Link>
						<TooltipComponent content='menu' postion='bottonCenter'>
							<button
								type='button'
								onClick={() => setActiveMenu(!activeMenu)}
								style={{ color: currentColor }}
								className='text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden'
							>
								<MdOutlineCancel />
							</button>
						</TooltipComponent>
					</div>


					<div className='mt-10'>
						{links
							.filter((item) => item.enabled)
							.map((item) => (
								<div key={item.title}>
									<p className='text-gray-400 dark:text-gray-400 m-3 mt-4 uppercase'>
										{item.title}
									</p>
									{item.links.filter(item => item.enabled).map((link) => (
										<NavLink
											to={`/${link.value}`}
											key={link.value}
											onClick={handleCloseSidebar}
											style={({ isActive }) => ({
												backgroundColor: isActive ? currentColor : '',
											})}
											className={({ isActive }) =>
												isActive ? activeLink : normalLink
											}
										>
											{link.icon}
											<span className='capitalize'>{link.name}</span>
										</NavLink>
									))}
								</div>
							))}
					</div>
				</>
			)}
		</div>
	);
};

export default Sidebar;
